/**
 * Model for contact details.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class Communication {
    id: number;
    entityId: number;
    type: number;
    details: string;
}



// WEBPACK FOOTER //
// ./src/app/entities/details/contactinformation/communication.model.ts